<!--<div class="row align-items-center p-b-10">
  <div class="col-sm-12 col-lg-12">
    <div class="d-flex align-items-center flexmob">
      <div class="m-l-10 d-flex align-items-center">
        <div>
          <button mat-fab style="width: 50px;height: 50px;border-radius: 20%;" class="brandbglight">
            <i-tabler name="fingerprint" class="icon-28" style="line-height: 30px !important"></i-tabler>
          </button>
        </div>
        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Auditor's Report
          </h4>
        </div>
      </div>
    </div>
  </div>
</div>-->
<div class="row align-items-center p-b-10">
  <div class="col-sm-12 col-lg-12">

    <div class="d-flex align-items-center flexmob">

      <!--<div class="d-flex align-items-center f-s-14 text-black-25 m-l-10 border-right p-x-10 cursor-pointer f-w-600" (click)="backToCharityOverView()">-->
      <div class="d-flex align-items-center f-s-14 text-black-25 border-right p-r-10 cursor-pointer f-w-600" (click)="backToCharityOverView()">
        <!--<i-tabler class="icon-20 m-r-4 m-t-0 anim" name="arrow-left"></i-tabler> Back to Charity Overview-->
        <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-left"></i-tabler> Back to Charity Overview
      </div>
      <div class="m-l-10 d-flex align-items-center">

        <div class="m-l-10">
          <!--<h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Balance Sheet <span class="f-s-14 f-w-400">(As at {{currentPeriodEnd}})</span>
          </h4>-->
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Auditor's Report
          </h4>
          <h5 class="f-s-14  text-black-25 m-t-5 ">
            <!--{{FinancialYear}}-->
          </h5>
        </div>
      </div>


    </div>
  </div>
  <div class="col-sm-12 col-lg-6  text-end">

    <div class="d-flex align-items-center justify-content-end">


    </div>
  </div>
</div>


<!--Period Finalised & Ready to Submit-->
<ng-template #otherUI>
  <div *ngIf="apFinalised " class="col-md-12 col-lg-12 m-t-20 p-0">
    <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #fed7aa !important; background: #fff7ed; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
      <mat-card-content class="p-y-20">
        <div class="row align-items-center">
          <div class="col-md-8">
            <div class="d-flex align-items-center">
              <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #ff9f1f; background: #ffedd5; display: flex; align-items: center; justify-content: center;" class="text-warning">
                <i-tabler name="lock" class="icon-24" style="color: #ea580c;"></i-tabler>
              </div>
              <!--<div>
              <h4>Period Finalised & Ready to Submit</h4>
              <p class="m-y-2">Accounts have been finalised and are now ready to submit</p>
              </div>-->
              <div class="m-l-10">
                <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                  Period Finalised & Ready to Submit
                </h4>
                <div>
                  <h5 class="f-s-14 f-w-600 m-x-4">Accounts have been finalised and are now ready to submit </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right lockUnlockRes">
            <div class="d-flex gap-10 justify-content-end custom-cards-trial">
              <button mat-flat-button class="rounded-5" style="border: 1px solid #fdba74; background:#fff;" (click)="UnfreezeAP()">
                <div class="d-flex text-black">
                  <i-tabler class="icon-20 m-r-4 m-t-0" name="lock-open" style="color: #c2410c;"></i-tabler><span class="f-s-14" style="color: #c2410c;">Unlock</span>
                </div>
              </button>
              <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="gotoSubmissions()">
                <div class="d-flex text-black">
                  <!--<i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler>--><span class="f-s-14 text-white">Submit</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
<!--Period Finalised & Ready to Submit ends-->
<!--Period Submitted-->
<div *ngIf="apFinalised &&  this.UserRoleAccess?.currentAPSubmitStatus != 'Not Submit' && this.UserRoleAccess?.currentAPSubmitStatus  !== 'Failed' ; else otherUI" class="col-md-12 col-lg-12 p-0 m-t-20">
  <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #A7F3D0 !important; background: #ECFDF5; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
    <mat-card-content class="p-y-20">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="d-flex align-items-center">
            <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #9ee9c2; background: #d1fae5; display: flex; align-items: center; justify-content: center; " class="text-warning">
              <i-tabler name="circle-check" class="icon-30" style="color: #059669;"></i-tabler>
            </div>
            <div class="m-l-10">
              <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                Period Submitted
              </h4>
              <div>
                <h5 class="f-s-14 f-w-600 m-x-4">Submitted to Companies House on {{this.UserRoleAccess?.currentAPSubmitDate}}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 text-right lockUnlockRes">
          <div class="d-flex gap-10 justify-content-end custom-cards-trial">
            <button mat-flat-button color="primary" class="rounded-5 successBtn" (click)="UnlockandAmend()">
              <div class="d-flex">
                <i-tabler class="icon-20 m-r-4 m-t-0" name="reload"></i-tabler><span class="f-s-14">Unlock & Amend Accounts</span>
              </div>
            </button>
          </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>
<!--Ends Period Submitted-->
<div class="m-t-12">

  <!--<div class="col-12 p-0">
    <mat-card class="">
      <mat-card-content>

        <p class="f-s-14">The TAR provides stakeholders with important information about your charity's activities, achievements, and governence.</p>
        <div class=""> </div>
        <div class="row align-items-start">
          <div class="col-lg-6">
            <h4 class="f-s-14">Do you want to include trust Annual Report in your Accounts?</h4>
          </div>
          <div class="col-lg-6 text-left">
            <div class="ar d-flex flex-column" style="flex-direction: column;">
              <mat-radio-button value='yes' [checked]="showContent" (keydown)="setVisibility($event)">Yes</mat-radio-button>
              <mat-radio-button value='no' [checked]="!showContent" (keydown)="setVisibility($event)">No</mat-radio-button>
            </div>
          </div>
        </div>

      </mat-card-content>
    </mat-card>
  </div>-->
  <div>

    <mat-card class="mat-card-top notes-app cardWithShadow overflow-hidden" style="height: 64vh;">
      <mat-sidenav-container class="h-100 bg-white">
        <mat-sidenav #sidenav mode="side" opened [mode]="mobileQuery.matches ? 'over' : 'side'"
                     [opened]="!mobileQuery.matches"
                     [fixedInViewport]="mobileQuery.matches">

          <ng-scrollbar class="position-relative">
            <mat-list class="m-l-10 p-r-10 report-list" style="width: 340px !important;">
              <mat-list-item class="position-relative" [ngClass]="isActive==1 ? 'active-tab' : ''" (click)="tabOne()">
                <span matListItemTitle class="f-s-14 f-w-400">Opinion <span class="text-danger"> *</span></span>
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive==2 ? 'active-tab' : ''" (click)="tabTwo1()">
                <span matListItemTitle class="f-s-14 f-w-400">Basis for Opinion </span>
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive==3 ? 'active-tab' : ''" (click)="tabThree1()">
                <span matListItemTitle class="f-s-14 f-w-400">Conclusions relating to going concern</span>
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive==4 ? 'active-tab' : ''" (click)="tabFour1()">
                <span matListItemTitle class="f-s-14 f-w-400">Other information</span>
              </mat-list-item>

              <mat-list-item *ngIf="audited_Type === 'companiesact2006'" class="position-relative" [ngClass]="isActive==5 ? 'active-tab' : ''" (click)="tabFive1()" style="height: 60px;">
                <span matListItemTitle class="f-s-14 f-w-400">Opinion on other matter prescribed by the Companies Act 2006</span>
              </mat-list-item>

              <mat-list-item class="position-relative" [ngClass]="isActive==6 ? 'active-tab' : ''" (click)="tabSix1()" style="height: 60px;">
                <span matListItemTitle class="f-s-14 f-w-400">Matters on which we are required to report by exception</span>
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive==7 ? 'active-tab' : ''" (click)="tabSeven1()">
                <span matListItemTitle class="f-s-14 f-w-400">Responsibilities of trustees</span>
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive==8 ? 'active-tab' : ''" (click)="tabEight1()" style="height: 60px;">
                <!--<span matListItemTitle class="f-s-14 f-w-400">Auditor’s responsibility for the audit of the financial statements </span>-->
                <span matListItemTitle class="f-s-14 f-w-400">Auditor&#39;s responsibility for the audit of the financial statements</span>

              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive==9 ? 'active-tab' : ''" (click)="tabNine1()">
                <span matListItemTitle class="f-s-14 f-w-400">Use of this report </span>
              </mat-list-item>
              <!--<mat-list-item *ngIf="account_Type == 'Amended'||account_Type == 'amended'" class="position-relative" [ngClass]="isActive==10 ? 'active-tab' : ''" (click)="tabTen1()">
                <span matListItemTitle class="f-s-14 f-w-400">Add</span>
              </mat-list-item>-->
              <mat-list-item class="position-relative" [ngClass]="isActive==11 ? 'active-tab' : ''" (click)="tabEleven1()">
                <span matListItemTitle class="f-s-14 f-w-400">Declaration </span>
              </mat-list-item>

            </mat-list>
          </ng-scrollbar>
        </mat-sidenav>

        <!-- Mobile top nav -->
        <div *ngIf="mobileQuery.matches" class="mobile-top-nav m-b-10">
          <ng-scrollbar class="position-relative">
            <mat-list class="m-l-10 p-r-10 report-list">
              <mat-list-item class="position-relative" [ngClass]="isActive==1 ? 'active-tab' : ''" (click)="tabOne()">
                <span matListItemTitle class="f-s-14 f-w-400">Opinion </span>
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive==2 ? 'active-tab' : ''" (click)="tabTwo1()">
                <span matListItemTitle class="f-s-14 f-w-400">Basis for Opinion </span>
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive==3 ? 'active-tab' : ''" (click)="tabThree1()">
                <span matListItemTitle class="f-s-14 f-w-400">Conclusions relating to going concern</span>
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive==4 ? 'active-tab' : ''" (click)="tabFour1()">
                <span matListItemTitle class="f-s-14 f-w-400">Other information</span>
              </mat-list-item>

              <mat-list-item *ngIf="audited_Type === 'companiesact2006'" class="position-relative" [ngClass]="isActive==5 ? 'active-tab' : ''" (click)="tabFive1()" style="height: 60px;">
                <span matListItemTitle class="f-s-14 f-w-400">Opinion on other matter prescribed by the Companies Act 2006</span>
              </mat-list-item>

              <mat-list-item class="position-relative" [ngClass]="isActive==6 ? 'active-tab' : ''" (click)="tabSix1()" style="height: 60px;">
                <span matListItemTitle class="f-s-14 f-w-400">Matters on which we are required to report by exception</span>
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive==7 ? 'active-tab' : ''" (click)="tabSeven1()">
                <span matListItemTitle class="f-s-14 f-w-400">Responsibilities of trustees</span>
              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive==8 ? 'active-tab' : ''" (click)="tabEight1()" style="height: 60px;">
                <!--<span matListItemTitle class="f-s-14 f-w-400">Auditor’s responsibility for the audit of the financial statements </span>-->
                <span matListItemTitle class="f-s-14 f-w-400">Auditor&#39;s responsibility for the audit of the financial statements</span>

              </mat-list-item>
              <mat-list-item class="position-relative" [ngClass]="isActive==9 ? 'active-tab' : ''" (click)="tabNine1()">
                <span matListItemTitle class="f-s-14 f-w-400">Use of this report </span>
              </mat-list-item>
              <!--<mat-list-item *ngIf="account_Type == 'Amended'||account_Type == 'amended'" class="position-relative" [ngClass]="isActive==10 ? 'active-tab' : ''" (click)="tabTen1()">
                <span matListItemTitle class="f-s-14 f-w-400">Add</span>
              </mat-list-item>-->
              <mat-list-item class="position-relative" [ngClass]="isActive==11 ? 'active-tab' : ''" (click)="tabEleven1()">
                <span matListItemTitle class="f-s-14 f-w-400">Declaration </span>
              </mat-list-item>

            </mat-list>
          </ng-scrollbar>
        </div>

        <!--<ng-scrollbar class="position-relative" style="height: calc(75vh - 50px);">-->
        <mat-card-content [formGroup]="AuditorForm">


          <div class="" *ngIf="activeTabOne">
            <fieldset [disabled]="apFinalised">
              <mat-card-title class="p-x-0 mat-mdc-card-title ">
                <h4 class="f-s-16 f-w-600 text-left" style=" background: #10756e; padding: 10px; color: #fff;">Opinion </h4>
              </mat-card-title>


              <div class="col-sm-12 col-sm-12 bg-white border-radius10 m-b-0 p-10 p-b-0 m-t-14">
                <div class="row align-items-center">
                  <div class="col-md-3">
                    <div class="label">
                      <h4 class="f-s-14">Opinion Type</h4>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <div class="radio-selection">
                      <mat-radio-group aria-label="Select an option">
                        <mat-radio-button value='Yes' [checked]="ischecked" (change)="setVisibility($event)" class="m-r-16">Qualified Opinion</mat-radio-button>
                        <mat-radio-button value='No' [checked]="!ischecked" (change)="setVisibility($event)" checked>Unqualified Opinion</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </div>
              </div>


              <mat-card-content class="m-t-10 p-x-0">
                <div class="p-b-10 d-flex justify-content-end">
                  <button mat-flat-button class="bg-none text-primary" style="height: 30px;" (click)="DefaultStatement('opinion')">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <ngx-editor-menu [editor]="editor1" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                  <ngx-editor [editor]="editor1" formControlName="opinion" (input)="dirty()" [disabled]="apFinalised" class="f-s-14" [placeholder]="'Type here...'">

                  </ngx-editor>
                </div>
              </mat-card-content>
              <!--<mat-error style="padding-left:inherit !important" *ngIf="AuditorForm.get('opinion')?.touched && AuditorForm.get('opinion')?.hasError('required')">
                Please enter data
              </mat-error>-->
            </fieldset>
          </div>



          <div class="" *ngIf="activeTabTwo">
            <fieldset [disabled]="apFinalised">
              <mat-card-title class="p-x-0 mat-mdc-card-title ">
                <h4 class="f-s-16 f-w-600 text-left" style=" background: #10756e; padding: 10px; color: #fff;">Basis for Opinion </h4>
              </mat-card-title>

              <mat-card-content class="m-t-20 p-x-0">
                <div class="p-b-10 d-flex justify-content-end">
                  <button mat-flat-button class="bg-none text-primary" style="height: 30px;" (click)="DefaultStatement('basisofOpinion')">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" [disabled]="apFinalised" class=""> </ngx-editor-menu>
                  <ngx-editor [editor]="editor" formControlName="basisofOpinion" (input)="dirty()" [disabled]="apFinalised" class="f-s-14" [placeholder]="'Type here...'"></ngx-editor>
                </div>
              </mat-card-content>
            </fieldset>
            <!--<mat-error style="padding-left:inherit !important" *ngIf="AuditorForm.get('basisofOpinion')?.touched && AuditorForm.get('basisofOpinion')?.hasError('required')">
              Please enter data
            </mat-error>-->
          </div>


          <div class="" *ngIf="activeTabThree">
            <fieldset [disabled]="apFinalised">
              <mat-card-title class="p-x-0 mat-mdc-card-title ">
                <h4 class="f-s-16 f-w-600 text-left" style=" background: #10756e; padding: 10px; color: #fff;">Conclusions relating to going concern </h4>
              </mat-card-title>

              <mat-card-content class="m-t-20 p-x-0">
                <div class="p-b-10 d-flex justify-content-end">
                  <button mat-flat-button class="bg-none text-primary" style="height: 30px;" (click)="DefaultStatement('conclusions')">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <ngx-editor-menu [editor]="editor" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                  <ngx-editor [editor]="editor" formControlName="conclusions" (input)="dirty()" [disabled]="apFinalised" class="f-s-14" [placeholder]="'Type here...'"></ngx-editor>
                </div>
              </mat-card-content>
            </fieldset>
            <!--<mat-error style="padding-left:inherit !important" *ngIf="AuditorForm.get('conclusions')?.touched && AuditorForm.get('conclusions')?.hasError('required')">
              Please enter data
            </mat-error>-->

          </div>


          <div class="" *ngIf="activeTabFour">
            <fieldset [disabled]="apFinalised">
              <mat-card-title class="p-x-0 mat-mdc-card-title ">
                <h4 class="f-s-16 f-w-600 text-left" style=" background: #10756e; padding: 10px; color: #fff;">Other information </h4>
              </mat-card-title>

              <mat-card-content class="m-t-20 p-x-0">
                <div class="p-b-10 d-flex justify-content-end">
                  <button mat-flat-button class="bg-none text-primary" style="height: 30px;" (click)="DefaultStatement('otherInformation')">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <ngx-editor-menu [editor]="editor" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                  <ngx-editor [editor]="editor" formControlName="otherInformation" (input)="dirty()" [disabled]="apFinalised" class="f-s-14" [placeholder]="'Type here...'"></ngx-editor>
                </div>
              </mat-card-content>
            </fieldset>
            <!--<mat-error style="padding-left:inherit !important" *ngIf="AuditorForm.get('otherInformation')?.touched && AuditorForm.get('otherInformation')?.hasError('required')">
              Please enter data
            </mat-error>-->
          </div>


          <div *ngIf="activeTabFive">
            <fieldset [disabled]="apFinalised">
              <mat-card-title class="p-x-0 mat-mdc-card-title ">
                <h4 class="f-s-16 f-w-600 text-left" style=" background: #10756e; padding: 10px; color: #fff;">
                  Opinion on other matter prescribed by the Companies Act 2006
                </h4>
              </mat-card-title>

              <mat-card-content class="m-t-20 p-x-0">
                <div *ngIf="audited_Type === 'companiesact2006'" class="p-b-10 d-flex justify-content-end">
                  <button mat-flat-button class="bg-none text-primary" style="height: 30px;"
                          (click)="DefaultStatement('othermattersprescribed')">
                    <span> Default Statement </span>
                  </button>
                </div>

                <div *ngIf="audited_Type === 'companiesact2006'"
                     class="NgxEditor__Wrapper"
                     style="min-height: 300px;">
                  <ngx-editor-menu [editor]="editor" [disabled]="apFinalised" [toolbar]="toolbar"></ngx-editor-menu>
                  <ngx-editor [editor]="editor"
                              formControlName="othermattersprescribed"
                              (input)="dirty()"
                              [disabled]="apFinalised"
                              class="f-s-14"
                              [placeholder]="'Type here...'">
                  </ngx-editor>
                </div>
              </mat-card-content>
            </fieldset>
          </div>


          <div class="" *ngIf="activeTabSix">
            <fieldset [disabled]="apFinalised">
              <mat-card-title class="p-x-0 mat-mdc-card-title ">
                <h4 class="f-s-16 f-w-600 text-left" style=" background: #10756e; padding: 10px; color: #fff;">Matters on which we are required to report by exception </h4>
              </mat-card-title>

              <mat-card-content class="m-t-20 p-x-0">
                <div class="p-b-10 d-flex justify-content-end">
                  <button mat-flat-button class="bg-none text-primary" style="height: 30px;" (click)="DefaultStatement('reportbyexception')">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <ngx-editor-menu [editor]="editor" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                  <ngx-editor [editor]="editor" formControlName="reportbyexception" (input)="dirty()" [disabled]="apFinalised" class="f-s-14" [placeholder]="'Type here...'"></ngx-editor>
                </div>
              </mat-card-content>
            </fieldset>
            <!--  <mat-error style="padding-left:inherit !important" *ngIf="AuditorForm.get('reportbyexception')?.touched && AuditorForm.get('reportbyexception')?.hasError('required')">
              Please enter data
            </mat-error>-->
          </div>


          <div class="" *ngIf="activeTabSeven">
            <fieldset [disabled]="apFinalised">
              <mat-card-title class="p-x-0 mat-mdc-card-title ">
                <h4 class="f-s-16 f-w-600 text-left" style=" background: #10756e; padding: 10px; color: #fff;">Responsibilities of trustees </h4>
              </mat-card-title>

              <mat-card-content class="m-t-20 p-x-0">
                <div class="p-b-10 d-flex justify-content-end">
                  <button mat-flat-button class="bg-none text-primary" style="height: 30px;" (click)="DefaultStatement('responsibilitiesoftrustees')">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <ngx-editor-menu [editor]="editor" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                  <ngx-editor [editor]="editor" formControlName="responsibilitiesoftrustees" (input)="dirty()" [disabled]="apFinalised" class="f-s-14" [placeholder]="'Type here...'"></ngx-editor>
                </div>
              </mat-card-content>
            </fieldset>
            <!-- <mat-error style="padding-left:inherit !important" *ngIf="AuditorForm.get('responsibilitiesoftrustees')?.touched && AuditorForm.get('responsibilitiesoftrustees')?.hasError('required')">
              Please enter data
            </mat-error>-->
          </div>


          <div class="" *ngIf="activeTabEight">
            <fieldset [disabled]="apFinalised">
              <mat-card-title class="p-x-0 mat-mdc-card-title ">
                <!--<span matListItemTitle class="f-s-14 f-w-400">Auditor&#39;s responsibility for the audit of the financial statements</span>-->

                <h4 class="f-s-16 f-w-600 text-left" style=" background: #10756e; padding: 10px; color: #fff;">Auditor&#39;s responsibility for the audit of the financial statements</h4>
              </mat-card-title>

              <mat-card-content class="m-t-20 p-x-0">
                <div class="p-b-10 d-flex justify-content-end">
                  <button mat-flat-button class="bg-none text-primary" style="height: 30px;" (click)="DefaultStatement('auditorresponsibilities')">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <ngx-editor-menu [editor]="editor" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                  <ngx-editor [editor]="editor" formControlName="auditorresponsibilities" (input)="dirty()" [disabled]="apFinalised" class="f-s-14" [placeholder]="'Type here...'"></ngx-editor>
                </div>
              </mat-card-content>
            </fieldset>
            <!--<mat-error style="padding-left:inherit !important" *ngIf="AuditorForm.get('auditorresponsibilities')?.touched && AuditorForm.get('auditorresponsibilities')?.hasError('required')">
              Please enter data
            </mat-error>-->
          </div>

          <div class="" *ngIf="activeTabNine">
            <fieldset [disabled]="apFinalised">
              <mat-card-title class="p-x-0 mat-mdc-card-title ">
                <h4 class="f-s-16 f-w-600 text-left" style=" background: #10756e; padding: 10px; color: #fff;">Use of this report  </h4>
              </mat-card-title>

              <mat-card-content class="m-t-20 p-x-0">
                <div class="p-b-10 d-flex justify-content-end">
                  <button mat-flat-button class="bg-none text-primary" style="height: 30px;" (click)="DefaultStatement('useofthisreport')">
                    <span class=""> Default Statement </span>
                  </button>
                </div>
                <div class="NgxEditor__Wrapper" style="min-height: 300px;">
                  <ngx-editor-menu [editor]="editor" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                  <ngx-editor [editor]="editor" formControlName="useofthisreport" [disabled]="apFinalised" (input)="dirty()" class="f-s-14" [placeholder]="'Type here...'"></ngx-editor>
                </div>
              </mat-card-content>
            </fieldset>
            <!--<mat-error style="padding-left:inherit !important" *ngIf="AuditorForm.get('useofthisreport')?.touched && AuditorForm.get('useofthisreport')?.hasError('required')">
              Please enter data [ngClass]="{ 'invalid-editor': AuditorForm.get('useofthisreport')?.value== '<p></p>' && AuditorForm.get('useofthisreport')?.touched }"
            </mat-error>-->
          </div>

          <div *ngIf="account_Type != 'Amended'&& account_Type != 'amended'">
            <div class="" *ngIf=" activeTabEleven">
              <fieldset [disabled]="apFinalised">
                <mat-card-title class="p-x-0 mat-mdc-card-title ">
                  <h4 class="f-s-16 f-w-600 text-left" style=" background: #10756e; padding: 10px; color: #fff;">Declaration</h4>
                </mat-card-title>
                <mat-card-content class="b-1 m-t-12 p-x-0 pb-30">
                  <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title" style="background: #e6f1f0;">
                    <div class="d-flex align-items-center p-y-20">
                      <div class="icon-holder">
                        <i-tabler class="icon-24 m-r-0 primary-color-dark" name="circle-check"></i-tabler>
                      </div>
                      <div class="">
                        <h4 class="f-s-16 primary-color-dark f-w-600 d-block">Declaration</h4>
                        <p class="f-s-14 m-0">Approve and sign the report on behalf of the board of Auditors.</p>
                      </div>
                    </div>
                  </mat-card-title>
                  <div class="p-x-14 m-y-10 row">
                    <div class="col-lg-4">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                        <div class="d-flex align-items-center">
                          <i-tabler class="icon-20 m-r-10 primary-color-dark" name="user"></i-tabler>
                          <h5 class="f-w-600 f-s-14">
                            Auditor Name<span class="text-danger"> *</span>
                          </h5>
                        </div>
                      </mat-label>
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-select placeholder="Select a Auditor" formControlName="approvedbyAuditor" (input)="dirty()" (blur)="Drpodownvalidate($event,'blur');dirty()" (selectionChange)="Drpodownvalidate($event,'selected');dirty()">
                          <mat-option *ngFor="let advisor of filteredAdvisors" [value]="advisor.advisorsId">
                            {{ advisor.professionalAdvisors_Name }}
                          </mat-option>
                        </mat-select>
                        <mat-error *ngIf="AuditorForm.get('approvedbyAuditor').hasError('required')">
                          Select an Auditor
                        </mat-error>
                      </mat-form-field>

                    </div>

                    <div class="col-lg-4" *ngIf="account_Type != 'Amended'&& account_Type != 'amended'">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                        <div class="d-flex align-items-center">
                          <i-tabler class="icon-20 m-r-10 primary-color-dark" name="calendar"></i-tabler>
                          <h5 class="f-w-600 f-s-14">
                            Original Approval Date<span class="text-danger"> *</span>
                          </h5>
                        </div>
                      </mat-label>
                      <mat-form-field appearance="outline" class="w-100">
                        <input matInput [matDatepicker]="picker" placeholder="dd/mm/yyyy" (input)="dirty()" formControlName="dateofAudit" appTextMaskDate (blur)="vlddateofapp($event);dirty()" (dateChange)="vlddateofapp($event);dirty()" [disabled]="apFinalised" />
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error *ngIf="AuditorForm.get('dateofAudit').hasError('required')">
                          Original Approval Date is required
                        </mat-error>
                        <mat-error *ngIf="AuditorForm.get('dateofAudit').hasError('IsAfterToday')">
                          Original Approval Date should be on or between Accounting Period Start and Today's Date
                        </mat-error>
                        <mat-error *ngIf="AuditorForm.get('dateofAudit').hasError('InvalidDate')">
                          Original Approval Date is invalid
                        </mat-error>
                        <mat-error *ngIf="AuditorForm.get('dateofAudit').hasError('BeforeAccountingPeriod')">
                          Original Approval Date should be on or between Accounting Period Start and Today's Date
                        </mat-error>
                      </mat-form-field>

                    </div>
                    <div class="col-lg-4">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                        <div class="d-flex align-items-center">
                          <i-tabler class="icon-20 m-r-10 primary-color-dark" name="report"></i-tabler>
                          <h5 class="f-w-600 f-s-14">
                            Accounting Body
                          </h5>
                        </div>
                      </mat-label>
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-select value="Other/None" formControlName="accountingBody" (selectionChange)="dirty()">
                          <mat-option value="Other/None">Other/None</mat-option>
                          <mat-option value="CIMA">CIMS</mat-option>
                          <mat-option value="AAT">AAT</mat-option>
                          <mat-option value="AIA">AIA</mat-option>
                          <mat-option value="IFA">IFA</mat-option>
                          <mat-option value="ACCA">ACCA</mat-option>
                          <mat-option value="ICAEW">ICAEW</mat-option>
                          <mat-option value="ICAS">ICAS</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-12 d-none">
                      <div class="rounded-2 b-1 p-14 m-y-6" style="border-radius: 6px; background: aliceblue;">
                        <p class="f-s-14 primary-color-dark">
                          The Trustees' annual report was approved on 17/09/2025 and signed on behalf of the board of trustees by: John Smith
                        </p>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </fieldset>

            </div>
          </div>
          <div *ngIf="account_Type == 'Amended'|| account_Type == 'amended'">
            <div class="" *ngIf=" activeTabEleven">
              <fieldset [disabled]="apFinalised">
                <mat-card-title class="p-x-0 mat-mdc-card-title ">
                  <h4 class="f-s-16 f-w-600 text-left" style=" background: #10756e; padding: 10px; color: #fff;">Declaration</h4>
                </mat-card-title>
                <mat-card-content class="b-1 m-t-12 p-x-0 p-b-30">
                  <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title" style="background: #e6f1f0;">
                    <div class="d-flex align-items-center p-y-20">
                      <div class="icon-holder">
                        <i-tabler class="icon-24 m-r-0 primary-color-dark" name="circle-check"></i-tabler>
                      </div>
                      <div class="">
                        <h4 class="f-s-16 primary-color-dark f-w-600 d-block">Declaration</h4>
                        <p class="f-s-14 m-0">Approve and sign the report on behalf of the board of Auditors.</p>
                      </div>
                    </div>
                  </mat-card-title>
                  <div class="p-x-14 m-y-10 row">
                    <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                        <div class="d-flex align-items-center">
                          <i-tabler class="icon-20 m-r-10 primary-color-dark" name="user"></i-tabler>
                          <h5 class="f-w-600 f-s-14">
                            Auditor Name<span class="text-danger"> *</span>
                          </h5>
                        </div>
                      </mat-label>
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-select placeholder="Select a Auditor" formControlName="approvedbyAuditor" (input)="dirty()" (blur)="Drpodownvalidate($event,'blur');dirty()"
                                    (selectionChange)="Drpodownvalidate($event,'selected');dirty()">
                          <mat-option *ngFor="let advisor of filteredAdvisors" [value]="advisor.advisorsId">
                            {{ advisor.professionalAdvisors_Name }}
                          </mat-option>
                        </mat-select>
                        <mat-error *ngIf="AuditorForm.get('approvedbyAuditor').hasError('required')">
                          Select an Auditor
                        </mat-error>
                      </mat-form-field>

                    </div>



                    <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                        <div class="d-flex align-items-center">
                          <i-tabler class="icon-20 m-r-10 primary-color-dark" name="calendar"></i-tabler>
                          <h5 class="f-w-600 f-s-14">
                            Original Approval Date<span class="text-danger"> *</span>
                          </h5>
                        </div>
                      </mat-label>
                      <mat-form-field appearance="outline" class="w-100">
                        <input matInput [matDatepicker]="picker" placeholder="dd/mm/yyyy" (input)="dirty()" formControlName="dateofAudit" appTextMaskDate
                               (blur)="vlddateofapp($event);dirty()" (dateChange)="vlddateofapp($event);dirty()" [disabled]="apFinalised" />
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error *ngIf="AuditorForm.get('dateofAudit').hasError('required')">
                          Original Approval Date is required
                        </mat-error>
                        <mat-error *ngIf="AuditorForm.get('dateofAudit').hasError('IsAfterToday')">
                          Original Approval Date should be on or between Accounting Period Start and Today's Date
                        </mat-error>
                        <mat-error *ngIf="AuditorForm.get('dateofAudit').hasError('InvalidDate')">
                          Original Approval Date is invalid
                        </mat-error>
                        <mat-error *ngIf="AuditorForm.get('dateofAudit').hasError('BeforeAccountingPeriod')">
                          Original Approval Date should be on or between Accounting Period Start and Today's Date
                        </mat-error>
                      </mat-form-field>

                      </div>
                      <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3">
                        <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                          <div class="d-flex align-items-center">
                            <i-tabler class="icon-20 m-r-10 primary-color-dark" name="calendar"></i-tabler>
                            <h5 class="f-w-600 f-s-14">
                              Revised Approval Date<span class="text-danger"> *</span>
                            </h5>
                          </div>
                        </mat-label>
                        <mat-form-field appearance="outline" class="w-100">
                          <input matInput [matDatepicker]="picker1" placeholder="dd/mm/yyyy" (input)="dirty()"
                                 formControlName="dateCharityAuditorsReportOnRevisedAccounts" appTextMaskDate
                                 (blur)="vldofrevised($event);dirty()" (dateChange)="RevisedDate_Validate($event);dirty()"  /> 
                          <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                          <mat-datepicker #picker1></mat-datepicker>
                          <mat-error *ngIf="AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts').hasError('required')">
                            Revised Approval Date is required
                          </mat-error>
                          <mat-error *ngIf="AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts').hasError('IsAfterToday')">
                            Revised Approval Date should be on or between Original Approval Date  and Today's Date
                          </mat-error>
                          <mat-error *ngIf="AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts').hasError('InvalidDate')">
                            Revised Approval Date is invalid
                          </mat-error>
                          <mat-error *ngIf="AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts').hasError('BeforeAccountingPeriod')||AuditorForm.get('dateCharityAuditorsReportOnRevisedAccounts').hasError('AfterOriginalDate')">
                            Revised Approval Date should be on or between Original Approval Date Start and Today's Date
                          </mat-error>
                         
                        </mat-form-field>

                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                        <div class="d-flex align-items-center">
                          <i-tabler class="icon-20 m-r-10 primary-color-dark" name="report"></i-tabler>
                          <h5 class="f-w-600 f-s-14">
                            Accounting Body
                          </h5>
                        </div>
                      </mat-label>
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-select value="Other/None" formControlName="accountingBody" (selectionChange)="dirty()">
                          <mat-option value="Other/None">Other/None</mat-option>
                          <mat-option value="CIMA">CIMS</mat-option>
                          <mat-option value="AAT">AAT</mat-option>
                          <mat-option value="AIA">AIA</mat-option>
                          <mat-option value="IFA">IFA</mat-option>
                          <mat-option value="ACCA">ACCA</mat-option>
                          <mat-option value="ICAEW">ICAEW</mat-option>
                          <mat-option value="ICAS">ICAS</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-lg-12 d-none">
                      <div class="rounded-2 b-1 p-14 m-y-6" style="border-radius: 6px; background: aliceblue;">
                        <p class="f-s-14 primary-color-dark">
                          The Trustees' annual report was approved on 17/09/2025 and signed on behalf of the board of trustees by: John Smith
                        </p>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </fieldset>

            </div>
          </div>
          <!--<div class="" *ngIf="activeTabTen">
          <fieldset [disabled]="apFinalised">
            <mat-card-title class="p-x-0 mat-mdc-card-title ">
              <h4 class="f-s-16 f-w-600 text-left" style=" background: #10756e; padding: 10px; color: #fff;">Add</h4>
            </mat-card-title>
            <mat-card-content class="b-1 m-t-12 p-x-0">
              <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title" style="background: #e6f1f0;">
                <div class="d-flex align-items-center p-y-20">
                  <div class="icon-holder">
                    <i-tabler class="icon-24 m-r-0 primary-color-dark" name="circle-check"></i-tabler>
                  </div>
                  <div class="">
                    <h4 class="f-s-16 primary-color-dark f-w-600 d-block">Add</h4>
                    <p class="f-s-14 m-0">Testing tab.</p>
                  </div>
                </div>
              </mat-card-title>
              <div class="p-x-14 m-y-10 row" *ngIf="account_Type == 'Amended'||account_Type == 'amended'" [formGroup]="AuditorForm">
                <div class="col-lg-4">
                  <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                    <div class="d-flex align-items-center">
                      <i-tabler class="icon-20 m-r-10 primary-color-dark" name="user"></i-tabler>
                      <h5 class="f-w-600 f-s-14">
                        Opinion Charity Auditors On RevisedAccounts
                      </h5>
                    </div>
                  </mat-label>-->
          <!--<mat-form-field appearance="outline" class="w-100">
            <mat-select placeholder="Select Auditor" formControlName="approvedbyAuditor">
              <mat-option value="John Smith">John Smith</mat-option>
            </mat-select>
          </mat-form-field>-->
          <!--<mat-form-field appearance="outline" class="w-100">
                      <input matInput placeholder="Pleae enter" formControlName="opinionCharityAuditorsOnRevisedAccounts">

                    </mat-form-field>

                  </div>
                  <div class="col-lg-4">
                    <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-20 m-r-10 primary-color-dark"></i-tabler>
                        <h5 class="f-w-600 f-s-14">
                          Opinion On Failure Original Accounts
                        </h5>
                      </div>
                    </mat-label>


                    <mat-form-field appearance="outline" class="w-100">
                      <input matInput placeholder="Pleae enter" formControlName="opinionOnFailureOriginalAccounts">

                    </mat-form-field>

                  </div>
                  <div class="row">

                    <div class="col-md-6 mb-3  ">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block  m-t-12 m-l-20">
                        Is Directors Trustees Report Consistent
                      </mat-label>
                      <mat-radio-group formControlName="isDirectorstrusteesReportConsistent"
                                       class="d-flex align-items-center gap-15 m-l-20">
                        <mat-radio-button [value]="true" color="primary">True</mat-radio-button>
                        <mat-radio-button [value]="false" color="primary">False</mat-radio-button>
                      </mat-radio-group>
                    </div>


                    <div class="col-md-6 mb-3">
                      <mat-label class="f-s-14 f-w-600 m-b-8 d-block">
                        <div class="d-flex align-items-center">
                          <i-tabler name="calendar" class="icon-20 m-r-10 primary-color-dark"></i-tabler>
                          <h5 class="f-w-600 f-s-14 m-0 text-nowrap">
                            Date Charity Auditors Report On Revised Accounts
                          </h5>
                        </div>
                      </mat-label>
                      <mat-form-field appearance="outline" class="w-100">
                        <input matInput [matDatepicker]="picker" placeholder="dd/mm/yyyy" appTextMaskDate (blur)="CurrentDate_Validate($event)">
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>


                </div>
              </mat-card-content>
            </fieldset>

          </div>-->


        </mat-card-content>
        <!--</ng-scrollbar>-->

      </mat-sidenav-container>
    </mat-card>
    <hr class="m-t-24" style="opacity:0.2" />
    <div class="row p-16 m-b-20">

      <div class="col-6 col-sm-6 col-md-4">
        <button mat-flat-button class="bg-warning text-end" (click)="Back()">
          <div class="d-flex text-black">
            <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black hidemenutext"> Back</span>
          </div>
        </button>
      </div>
      <div class="col-6 col-sm-6 col-md-8" align="right">
        <!--<button mat-flat-button   class="bgwhite border-light b-1 text-end m-r-10">
          <div class="d-flex text-black">
            <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
          </div>
        </button>-->
        <button mat-flat-button color="primary" class="bg-success rounded-5" [disabled]="!UserRoleAccess?.m1View" (click)="saveAndNext()">
          <div class="d-flex" *ngIf="this.activeTabTen == true">
            <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark hidemenutext"> Next</span>
          </div>
          <div class="d-flex" *ngIf="this.activeTabTen != true">
            <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark hidemenutext">  Next</span>
          </div>
        </button>
      </div>
    </div>
  </div>



  <!--<mat-paginator [pageSizeOptions]="[2, 3, 5]"(page)="onPageChange($event)" showFirstLastButtons *ngIf="CharityGrid?.length > 0"> </mat-paginator>-->

</div>
